/**
 * Serviço central para processamento e validação de geometrias CAR/SIGEF
 *
 * Este serviço orquestra os módulos utilitários para fornecer uma API consistente
 * para manipulação de geometrias em diferentes fluxos da aplicação.
 */

// Importação dos módulos utilitários
import * as validation from '../utils/geometry/validation';
import * as conversion from '../utils/geometry/conversion';
import * as detection from '../utils/geometry/detection';
import * as processing from '../utils/geometry/processing';

const DEBUG = import.meta.env.VITE_DEBUG === 'true';

/**
 * GeometryService: Serviço orquestrador para manipulação de geometrias
 */
const GeometryService = {
  // Funções de processamento (com instrumentação condicional)
  processPropertyGeometries: (...args) => {
    // eslint-disable-next-line no-console
    if (DEBUG) console.time('[Perf] Geom.processPropertyGeometries');
    try {
      return processing.processPropertyGeometries(...args);
    } finally {
      // eslint-disable-next-line no-console
      if (DEBUG) console.timeEnd('[Perf] Geom.processPropertyGeometries');
    }
  },
  processGeoJSON: (...args) => {
    // eslint-disable-next-line no-console
    if (DEBUG) console.time('[Perf] Geom.processGeoJSON');
    try {
      return processing.processGeoJSON(...args);
    } finally {
      // eslint-disable-next-line no-console
      if (DEBUG) console.timeEnd('[Perf] Geom.processGeoJSON');
    }
  },
  calculateCentroid: (...args) => {
    // eslint-disable-next-line no-console
    if (DEBUG) console.time('[Perf] Geom.calculateCentroid');
    try {
      return processing.calculateCentroid(...args);
    } finally {
      // eslint-disable-next-line no-console
      if (DEBUG) console.timeEnd('[Perf] Geom.calculateCentroid');
    }
  },
  safeParse: processing.safeParse,

  // Funções de validação e correção
  validateCoordinates: validation.validateCoordinates,
  validateAndFixCoordinates: validation.validateAndFixCoordinates,
  validateAndFixGeoJSONCoordinates: validation.validateAndFixGeoJSONCoordinates,
  isValidCoordinate: validation.isValidCoordinate,

  // Funções de detecção de formato
  needsCoordinateInversion: detection.needsCoordinateInversion,
  getSampleCoordinate: detection.getSampleCoordinate,
  getSampleCoordinateForDiagnostic: detection.getSampleCoordinateForDiagnostic,
  isInBrazilRange: detection.isInBrazilRange,
  isCoordInBrazil: detection.isCoordInBrazil,

  // Conversão UTM (mantida para compatibilidade, mas não mais usada automaticamente)
  convertUTMtoWGS84: conversion.convertUTMtoWGS84,
  isLikelyUTM: conversion.isLikelyUTM,
};

export default GeometryService;
